<script>
    import { onMount } from "svelte";
    import SecondaryNav from "./SecondaryNav.svelte";
    import Cookies from 'js-cookie';

    let root = "https://app.donorflow.net"
    export let showSecondary;
    export let secondaryNavItems;

    let portal;
    let username;
    let dft;

    function logout() {
        clearCredentials()
          .then(r => {
            logoutOfFBase();
            redirectLogoutOnServer();
          })
    };

    async function clearCredentials() {
        // Local storage:
    localStorage.removeItem('portal');
    localStorage.removeItem('lportal');
    localStorage.removeItem('dfp');
    localStorage.removeItem('dfud');
    localStorage.removeItem('df_explore');
    
    // Cookies:
    Cookies.remove('dfak');
    Cookies.remove('dfp');
    Cookies.remove('dft');
    Cookies.remove('dfud');
    Cookies.remove('dfusername');
    Cookies.remove('_DFSESSION');

    // Cookies from donorflow.net domain:
    Cookies.remove('dfak', { domain: 'donorflow.net' });
    Cookies.remove('dfp', { domain: 'donorflow.net' });
    Cookies.remove('dft', { domain: 'donorflow.net' });
    Cookies.remove('dfud', { domain: 'donorflow.net' });
    Cookies.remove('dfusername', { domain: 'donorflow.net' });
    Cookies.remove('_DFSESSION', { domain: 'donorflow.net' });

    return true;
    }
    function logoutOfFBase() {
        firebase.auth().signOut().then(function () {
          // Sign-out successful.
        }).catch(function (error) {
          // An error happened.
          console.log(error);
        });
    }
    function redirectLogoutOnServer(params) {
        window.location.href = 'https://app.donorflow.net/auth/logout';
    }
    onMount(() => {
        if (!firebase.apps.length) {
			firebase.initializeApp(firebaseConfig);
		};
        portal = localStorage.getItem("lportal");
        username = Cookies.get('dfusername');
        dft = Cookies.get('dft');
    });
    
</script>

<style>
    .df-navbar {
        background-color: #ffdf11;
        color: #282300;
        height: 60px;
        align-items: center;
        font-size: 16px;
    }
    .df-navbar__brand {
        background-color: #ffdf11;
        width: 60px;
        text-align: center;
        font-size: 1.3rem;
        line-height: 60px;
        margin-right: 20px;
    }
    .df-navdropdown {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .df-navdropdown .df-contents {
        padding-top: 12px;
        cursor: pointer;
    }
    .df-navdropdown__title {
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        padding: 0px 10px;
        -webkit-font-smoothing: antialiased;
    }
    .df-navdropdown__chevron {
        background-color: #ffdf11;
        height: 10px;
        line-height: 10px;
        color: #282300 !important;
        text-align: center;
    }
    .df-navdropdown__activeindicator {
        height: 2px;
        background-color: #ffdf11;
        padding-bottom: 2px;
    }
    .df-navdropdown__activeindicator span {
        display: block;
        height: 2px;
        background-color: #ffdf11 !important;
        width: 80%;
        margin: 0 auto;
    }
    .df-navmenu {
        position: absolute;
        background-color: #ffdf11;
        border-radius: 3px;
        line-height: 16px;
        min-width: 150px;
        z-index: 9999;
        padding: 15px 0px;
    }
    .std-link {
        display: block;
        padding: 15px 15px;
        color: #282300 !important;
    }
    .std-link:hover {
        background-color: #ffea62;
        text-decoration: none !important;
    }
    .df-navmenu a {
        display: block;
        padding: 15px 15px;
        color: #282300 !important;
    }
    .df-navmenu a:hover {
        background-color: #ffea62;
        text-decoration: none !important;
    }
    .df-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        -webkit-font-smoothing: antialiased;
        padding: 0px 10px;
        background-color: #ffdf11;
        color: #282300;
        height: 40px;
        line-height: 40px;
    }
    .df-item:hover {
        color: #282300;
        text-decoration: none;
    }
    .df-search {
        font-size: 1.2rem;
    }
    .df-navdivider hr {
        border-top: 1px solid #fff;
    }
    li {
        list-style: none;
    }
    .df-contents:hover ul.df-navmenu {
        display: block;
    }
    .df-navmenu {
        display: none;
    }
    /* .navbar-active:hover + .df-navmenu {
        display: block;
    }
    .show {
        display: block;
    } */
</style>

<div class="d-flex df-navbar d-print-none">
    <div class="df-navbar__brand">
        <a href="/dashboard"><img
                src="https://s.donorflow.net/images/donorflow_email.png"
                alt="Donorflow"
                height="40px" /></a>
    </div><a class="df-item" href={root + `/dashboard`}>Home</a>
    <ul class="df-navdropdown">
        <li class="df-contents">
            <span class="df-navmenuitem">
                <div class="df-navdropdown__title">Fundraising</div>
                <div class="df-navdropdown__activeindicator">
                    <span
                        style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                </div>
                <div class="df-navdropdown__chevron">▾</div>
            </span>
            <ul class="df-navmenu">
                <li><a href={root+`/donations`}>Donations</a></li>
                {#if portal === '3'}
                    <!-- content here -->
                    <li>
                        <a
                            href={root + `/subscriptions/new_subscriptions`}>Autogiro
                            subscriptions</a>
                    </li>
                {:else}
                    <li>
                        <a href={root + `/subscriptions`}>Autogiro
                            subscriptions</a>
                    </li>
                {/if}
                <li>
                    <a href={root + `/deals/board`}>Pipelines & Deals</a>
                </li>
            </ul>
        </li>
    </ul>
    <ul class="df-navdropdown">
        <li class="df-contents">
            <span class="df-navmenuitem">
                <div class="df-navdropdown__title">Marketing</div>
                <div class="df-navdropdown__activeindicator">
                    <span
                        style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                </div>
                <div class="df-navdropdown__chevron">▾</div>
            </span>
            <ul class="df-navmenu">
                <li>
                    <a
                        href={root + `/campaigns/${portal}`}>Campaigns</a>
                </li>
                <li><a href={root + `/forms`}>Forms</a></li>
            </ul>
        </li>
    </ul>
    <ul class="df-navdropdown">
        <li class="df-contents">
            <span class="df-navmenuitem">
                <div class="df-navdropdown__title">Contacts</div>
                <div class="df-navdropdown__activeindicator">
                    <span
                        style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                </div>
                <div class="df-navdropdown__chevron">▾</div>
            </span>
            <ul class="df-navmenu">
                <li><a href={root + `/contacts`}>Contacts</a></li>
                <li>
                    <a href={root + `/contacts/people`}>People</a>
                </li>
                <li>
                    <a
                        href={root + `/contacts/companies`}>Companies</a>
                </li>
                <li>
                    <a
                        href={root + `/contacts/organizations`}>Organizations</a>
                </li>
                <li class="df-navdivider">
                    <hr />
                </li>
                <li><a href={root + `/lists/${portal}`}>Lists</a></li>
            </ul>
        </li>
    </ul>
    <ul class="df-navdropdown">
        <li class="df-contents">
            <span class="df-navmenuitem">
                <div class="df-navdropdown__title">Analytics</div>
                <div class="df-navdropdown__activeindicator">
                    <span
                        style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                </div>
                <div class="df-navdropdown__chevron">▾</div>
            </span>
            <ul class="df-navmenu">
                <li><a href={root+`/analytics/#/reports`}>Donations</a></li>
                <li><a href={root+`/analytics`}>Explore donors</a></li>
                <li><a href={root+`/analytics/#/segments`}>Segments</a></li>
                <li><a href={root+`/analytics/#/products`}>Products</a></li>
            </ul>
        </li>
    </ul>
    <ul class="df-navdropdown">
        <li class="df-contents">
            <span class="df-navmenuitem">
                <div class="df-navdropdown__title">Tools</div>
                <div class="df-navdropdown__activeindicator">
                    <span
                        style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                </div>
                <div class="df-navdropdown__chevron">▾</div>
            </span>
            <ul class="df-navmenu">
                <li><a href={root + `/donationboxes`}>Donation Boxes</a></li>
                <li><a href={`https://giftcards.donorflow.net/?token=${dft}`}>Goodness Cards</a></li>
                <li><a href={root + `/swishlinks/3`}>Swish links</a></li>
                <li><a href={root + `/messagetemplates/3`}>Message Templates</a></li>
                <li><a href={root + `/forms`}>Lead Generation Forms</a></li>
                <li class="df-navdivider">
                    <hr />
                </li>
                <li><a href={root + `/apps/3/all`}>Integrations &amp; Apps</a></li>
                <li><a href={root + `/data-management/3/swish`}>Import: Swish</a></li>
            </ul>
        </li>
    </ul>

    <a class="df-item df-search" href={root + '/search'}><svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 512 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"><path
                d="M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z" /></svg></a>
    <div class="d-flex" style="position: absolute; right: 30px;">
        <ul class="df-navdropdown">
            <li class="df-contents">
                <span class="df-navmenuitem">
                    <div
                        class="df-navdropdown__title"
                        style="font-size: 1.1rem;">
                        {#if username}
                            {username}
                        {:else}
                            <i class="bx bx-user-circle" />
                        {/if}
                    </div>
                    <div class="df-navdropdown__activeindicator">
                        <span
                            style="background-color: rgb(62, 62, 81);">&nbsp;</span>
                    </div>
                    <div class="df-navdropdown__chevron">▾</div>
                </span>
                <ul class="df-navmenu mr-4">
                    <li><a href={root + `/reminders/${portal}`}>Reminders</a></li>
                    <li>
                        <a href={root + `/portal`}><i class="bx bx-cog" />
                            Settings</a>
                    </li>
                    <li>
                        <div class="std-link" on:click={logout}>Logout</div>
                    </li>
                </ul>
            </li>
        </ul>
        <div style="margin-top: 8px;">
            <a class="df-item" href="https://app.donorflow.net/help">Help</a>
        </div>
    </div>
</div>
{#if showSecondary}
<SecondaryNav
    items={secondaryNavItems}
/>
{/if}

